










import { Vue, Component } from 'vue-property-decorator';
import CamaraEnVivo from '@/pantallas/Camaras/EnVivo/CamaraEnVivo.vue';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';

@Component({
  components: { CamaraEnVivo },
})
export default class CamaraEnVivoPantalla extends Vue {
  moduleType: string = '';

  created() {
    var self = this;
    CamaraEventBus.$on('reloadComponentInLives', () => {
      //self.chargePatentsCamera();
      let url = new URL(window.location.href);
      self.changedModule();
    });
  }

  mounted() {
    this.changedModule();
  }

  changedModule() {
    let url = new URL(window.location.href);
    this.moduleType =
      url.pathname != '/camaras-envivo' ? 'En Vivo Cámaras' : 'En vivo';
  }
}
